import { useTranslation } from '@eti/providers';
import OrderInfoContainer from '../containers/OrderInfoContainer';

const OrderInfoTextResolver = (props) => {
  const { t } = useTranslation();

  const namesWithTranslations = {
    airHelp: t('airHelpTitle'),
    allInclusiveProtection: t('allInclusiveProtectionTitle'),
    baggageService: t('baggageServiceName'),
    bankruptcyInsuranceCoverGenius: t('bankruptcyInsuranceCoverGeniusTitle'),
    cabinBaggage: t('cabinBaggageTitle') || t('cabinBaggagePerTravelerTitle'),
    cabinUpgrade: t('cabinUpgradeTitle'),
    cancelForAnyReason: t('cancelForAnyReasonTitle'),
    cancellationGuarantee: t('cancellationGuaranteeTitle'),
    cancellationInsideEu: t('cancellationInsideEUTitle'),
    cancellationOutsideEu: t('cancellationOutsideEUTitle'),
    checkInBaggage: t('checkInBaggageName'),
    cancellationInsuranceCoverGenius: t('cancellationInsuranceCoverGeniusTitle'),
    cancelTwentyFourHours: t('cancelTwentyFourHoursTitle'),
    comprehensiveInsuranceCoverGenius: t('comprehensiveInsuranceCoverGeniusTitle'),
    co2Compensation: t('co2CompensationTitle'),
    fastTrack: t('fastTrackTitle'),
    flexibleTicket: t('flexibleTicketHeaderTitle'),
    meal: t('mealName'),
    mobileTravelPlan: t('mobileTravelPlanTitle'),
    lounge: t('loungeTitle'),
    onlineCheckIn: t('onlineCheckInTitle'),
    seatMap: t('seatMapTitle'),
    simpleVisa: t('simpleVisaTitle'),
    sms: t('smsTitle'),
    travelDocsPost: t('travelDocsPostTitle'),
    travelInsuranceInsideEu: t('travelInsuranceInsideEUTitle'),
    travelInsuranceOutsideEu: t('travelInsuranceOutsideEUTitle'),
    travelInsuranceCoverGenius: t('travelInsuranceCoverGeniusTitle'),
    tripCancellationProtection: t('tripCancellationProtectionTitle'),
    platinum: t('platinumTitle'),
  };

  return <OrderInfoContainer {...props} names={namesWithTranslations} />;
};
export default OrderInfoTextResolver;
